import React from 'react'
import PdfViewer from '../PdfViewer';
import {STATUS} from 'service/base_url'
export default function FilePdf(props) {
    let {url}=props
    return (
        <PdfViewer url={url} width={560} style={{height:'unset'}} />
    )
}
